import React from 'react'
import { Divider } from 'antd'

export const TurnTicketFactura = React.forwardRef((props, ref) => {
  const { storeTurnState, sellByNewMethods, sold } = props
  const sellByNewMethodsAux = sellByNewMethods.filter(value => Object.keys(value).length !== 0);

  sellByNewMethodsAux.forEach(element => {
    const totalSoldObj = sold.find(turn => turn.id_payment_method === element.payment_method_id)
    sellByNewMethodsAux.total_sold = totalSoldObj.total_sold
  });

  storeTurnState.sold_with_other_payment_methods.forEach(element => {
    if (sellByNewMethodsAux.length > 0) {
      const found = sellByNewMethodsAux.find(method => method.id_payment_method === element.payment_method_id)
      element.total_sold = found.total_sold
    }
  });


  return (
    <div ref={ref} style={{ textAlign: 'center' }} className='ticket-modal'>
      <br />
      {/* <img src="tendero-logo-lg.png" className={'login-logo-lg'} alt={'moocho'} /> */}
      <br />
      <h1 style={{ color: 'var(--tendero-green)', fontSize: 'xxx-large' }}>{'Cierre de Turno'}</h1>
      <p>{storeTurnState.company ? storeTurnState.company : storeTurnState?.store?.company?.name}</p>
      <p>{storeTurnState.nit ? storeTurnState.nit : storeTurnState?.store?.company?.nit}</p>
      <p>{storeTurnState?.store?.company?.address}</p>
      <br></br>
      <p>{storeTurnState?.store?.name ? storeTurnState?.store?.name : storeTurnState?.store?.name}</p>
      <p>{storeTurnState?.store?.address ? storeTurnState?.store?.address : storeTurnState?.store?.address}</p>
      <br></br>
      <p>{'Vendedor'}</p>
      <p>{storeTurnState?.seller?.name}</p>
      <p>{`Turno ${storeTurnState?.id}`}</p>
      <br></br>
      <p>{storeTurnState.close_date}</p>
      <br />
      <br />
      <p>{`Cuadre en tarjeta`}</p>
      <br />
      <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2rem', marginRight: '2rem' }}>
        <p>{`Venta en tarjeta segun cierre`}</p>
        <p>{storeTurnState.store.company.currency.abbreviation}.{Number(storeTurnState.card_sales).toFixed(2)}</p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2rem', marginRight: '2rem' }}>
        <p>{`Venta en tarjeta segun POS`}</p>
        <p>{storeTurnState.store.company.currency.abbreviation}.{Number(storeTurnState.card_sales_pos).toFixed(2)}</p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'end', marginLeft: '2rem', marginRight: '2rem' }}>
        <p className={Number(storeTurnState.card_sales) === Number(storeTurnState.card_sales_pos) ? 'isOk' : 'isnotOk'}>
          {Number(storeTurnState.card_sales) === Number(storeTurnState.card_sales_pos) ? 'Cuadrado' : 'No cuadra'}
        </p>
      </div>

      <p>{`Cuadre en servicios externos`}</p>
      <br />
      <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2rem', marginRight: '2rem' }}>
        <p>{`Venta en servicios externos segun cierre`}</p>
        <p>{storeTurnState.store.company.currency.abbreviation}.{Number(storeTurnState.external_services_sales).toFixed(2)}</p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2rem', marginRight: '2rem' }}>
        <p>{`Venta en servicios externos segun registros`}</p>
        <p>{storeTurnState.store.company.currency.abbreviation}.{Number(storeTurnState.services_sales).toFixed(2)}</p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'end', marginLeft: '2rem', marginRight: '2rem' }}>
        <p className={Number(storeTurnState.external_services_sales) === Number(storeTurnState.services_sales) ? 'isOk' : 'isnotOk'}>
          {Number(storeTurnState.external_services_sales) === Number(storeTurnState.services_sales) ? 'Cuadrado' : 'No cuadra'}
        </p>
      </div>

      {storeTurnState.sold_with_other_payment_methods.map(item => {
        return (
          <>
            <p>{`Cuadre en ${item.name_payment_method}`}</p>
            <br />
            <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2rem', marginRight: '2rem' }}>
              <p>{`Venta en ${item.name_payment_method} segun cierre`}</p>
              <p>{storeTurnState.store.company.currency.abbreviation}.{Number(item.total_sold).toFixed(2)}</p>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2rem', marginRight: '2rem' }}>
              <p>{`Venta en ${item.name_payment_method} segun POS`}</p>
              <p>{storeTurnState.store.company.currency.abbreviation}.{Number(item.total_sold_with_payment_method).toFixed(2)}</p>
            </div>

            <div style={{ display: 'flex', justifyContent: 'end', marginLeft: '2rem', marginRight: '2rem' }}>
              <p className={Number(item.total_sold) === Number(item.total_sold_with_payment_method) ? 'isOk' : 'isnotOk'}>
                {Number(item.total_sold) === Number(item.total_sold_with_payment_method) ? 'Cuadrado' : 'No cuadra'}
              </p>
            </div>
          </>
        )
      })}

      <br />
      <p>{`Cuadre en circulante`}</p>
      <br />
      <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2rem', marginRight: '2rem' }}>
        <p>{`Turno empezó con`}</p>
        <p>{storeTurnState.store.company.currency.abbreviation}.{Number(storeTurnState.open_petty_cash_amount).toFixed(2)}</p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2rem', marginRight: '2rem' }}>
        <p>{`Gastado en compras`}</p>
        <p>{storeTurnState.store.company.currency.abbreviation}.{Number(storeTurnState.expenses_in_purchases).toFixed(2)}</p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2rem', marginRight: '2rem' }}>
        <p>{`Gastado en gastos(no compras)`}</p>
        <p>{storeTurnState.store.company.currency.abbreviation}.{Number(storeTurnState.expenses_in_not_purchases).toFixed(2)}</p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2rem', marginRight: '2rem' }}>
        <p>{`Depositado`}</p>
        <p>{storeTurnState.store.company.currency.abbreviation}.{Number(storeTurnState.deposits_total).toFixed(2)}</p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2rem', marginRight: '2rem' }}>
        <p>{`Vendido en efectivo`}</p>
        <p>{storeTurnState.store.company.currency.abbreviation}.{Number(storeTurnState.cash_sales).toFixed(2)}</p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2rem', marginRight: '2rem' }}>
        <p>{`Cobrado de cuentas por cobrar`}</p>
        <p>{storeTurnState.store.company.currency.abbreviation}.{Number(storeTurnState.cash_collected_in_receivables).toFixed(2)}</p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2rem', marginRight: '2rem' }}>
        <p>{`Ajustes realizados`}</p>
        <p>{storeTurnState.store.company.currency.abbreviation}.{Number(storeTurnState.cash_adjustments_total).toFixed(2)}</p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '6rem', marginRight: '2rem' }}>
        <p>{`Deberias tener`}</p>
        <p>{storeTurnState.store.company.currency.abbreviation}.{Number(storeTurnState.closed_petty_cash_amount).toFixed(2)}</p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '6rem', marginRight: '2rem' }}>
        <p>{`Tienes en tienda`}</p>
        <p>{storeTurnState.store.company.currency.abbreviation}.{Number(storeTurnState.cash_on_hand).toFixed(2)}</p>
      </div>

      <div style={{ display: 'flex', justifyContent: 'end', marginLeft: '2rem', marginRight: '2rem' }}>
        <p className={Number(storeTurnState.closed_petty_cash_amount) === Number(storeTurnState.cash_on_hand) ? 'isOk' : 'isnotOk'}>
          {Number(storeTurnState.closed_petty_cash_amount) === Number(storeTurnState.cash_on_hand) ? 'Cuadrado' : 'No cuadra'}
        </p>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <Divider className={'divider-custom-margins-nav'} type={'horizontal'} />
      <p>{`Firma Vendedor`}</p>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <Divider className={'divider-custom-margins-nav'} type={'horizontal'} />
      <p>{`Firma Supervisor`}</p>
    </div>
  );
});